import React from 'react'
const OurPurpose = () => {
    return (
        <section id="ourPurpose" className="our_purposeSection">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 text-center">
                        <div className="largeTxt">
                            <h2 className="h2">Our Purpose </h2>
                            Help Non-Profits to Serve Humanity by Providing Right Technology Solution
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OurPurpose